/**
 * Checkout Legacy Product ID Tracking
 * Reads legacy product IDs from local storage and sends to tracking systems
 */

document.addEventListener("DOMContentLoaded", function () {
  // Function to get legacy product IDs from local storage
  function getLegacyProductIdsFromStorage() {
    try {
      const stored = localStorage.getItem("legacy_product_ids");
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.log("Error reading legacy product IDs from storage:", error);
      return {};
    }
  }

  // Function to send legacy product ID to tracking systems
  function sendLegacyProductIdToTracking(variantId, legacyId) {
    // Google Analytics 4
    if (typeof gtag !== "undefined") {
      gtag("event", "view_item", {
        currency: "CHF",
        value: 0,
        items: [
          {
            item_id: legacyId,
            item_name: `Legacy Product ${legacyId}`,
            item_category: "Legacy Tracking",
            quantity: 1,
          },
        ],
        custom_map: {
          legacy_product_id: legacyId,
          variant_id: variantId,
        },
      });
    }

    // Facebook Pixel
    if (typeof fbq !== "undefined") {
      fbq("track", "ViewContent", {
        content_ids: [legacyId],
        content_type: "product",
        legacy_product_id: legacyId,
        variant_id: variantId,
      });
    }

    // Custom tracking endpoint
    if (window.legacyProductTrackingEndpoint) {
      fetch(window.legacyProductTrackingEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          variant_id: variantId,
          legacy_product_id: legacyId,
          timestamp: new Date().toISOString(),
          source: "checkout_tracking",
        }),
      }).catch((error) => console.log("Legacy product tracking error:", error));
    }
  }

  // Get legacy product IDs from local storage
  const legacyIds = getLegacyProductIdsFromStorage();

  // Send to tracking systems
  Object.entries(legacyIds).forEach(([variantId, legacyId]) => {
    if (legacyId && legacyId !== "") {
      sendLegacyProductIdToTracking(variantId, legacyId);
    }
  });

  // Make available globally for other scripts
  window.checkoutLegacyProductIds = legacyIds;

  // Simple API functions
  window.getLegacyProductId = function (variantId) {
    return legacyIds[variantId] || null;
  };

  window.getAllLegacyProductIds = function () {
    return { ...legacyIds };
  };
});
